<template>
  <div class="proposal-column">
    <column-header
      :title="trans('deal_dashboard.proposal.column_title')"
      :counter="proposals.length"
      class="proposal-column__header"
    />
    <div class="proposal-column__content">
      <dashboard-proposal
        v-for="proposal in proposals"
        :key="proposal.id"
        :proposal="proposal"
        @proposal-refused="(theProposal) => { $emit('proposal-refused', theProposal); }"
      />
    </div>
  </div>
</template>

<script>
import { translationMixin } from '@elements/translation';
import ColumnHeader from '../ColumnHeader.vue';
import DashboardProposal from './Proposal.vue';

export default {
  components: { ColumnHeader, DashboardProposal },
  mixins: [ translationMixin ],
  props: {
    proposals: { type: Array, required: true },
  },
};
</script>
